import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 20h15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v20l5-5Zm-2-3h16V6H6v11Z"
    />
  </svg>
);
export default IconCommentStrokedSizeL;
